import { Directive, HostListener } from '@angular/core';
import { BaseDirective } from './base.directive';

@Directive({
  selector: '[appNotEmpty]',
  standalone: true
})
export class NotEmptyInteger extends BaseDirective {

  constructor() { super(); }

  @HostListener('input', ['$event'])
  onInput(event: KeyboardEvent) {
    if (this.teclaPermitidaPresionada(event)) return;
    this.filterInput(event);
  }

  filterInput(event: KeyboardEvent) {
    if ((event.target as HTMLInputElement).value === '') {
      (event.target as HTMLInputElement).value = '0';
    }
  }
}
